import colors from "../../colors/colors";

export const borderZero = () => ({
  border: 0,
});

export const HorizontalDivider = () => ({
  color: colors.dropShadow[4],
  margin: "0.72rem 0 0.72rem 0",
});